import { Stack } from 'expo-router';
import { useTheme, PaperProvider } from 'react-native-paper';
import { View } from 'react-native';

export default function ResetPasswordLayout() {
  const theme = useTheme();

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background }}>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.background,
            flex: 1,
          },
          animation: 'none', // Disable animation for debugging
        }}
      />
    </View>
  );
} 